import { render, staticRenderFns } from "./EmailTypeDialog.vue?vue&type=template&id=06449e60&scoped=true"
import script from "./EmailTypeDialog.vue?vue&type=script&lang=js"
export * from "./EmailTypeDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailTypeDialog.vue?vue&type=style&index=0&id=06449e60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06449e60",
  null
  
)

export default component.exports